export const GITHUB_REPO = "https://github.com/bipoza/nahieran-js";

export const APPBAR_ITEMS = ["TV", "Radio", "Contributing"];